export enum ColumnName {
  Status = 'Status',
  Note = 'Note',
  PitchNo = 'Pitch',
  Pitcher = 'Pitcher',
  Catcher = 'Catcher',
  Batter = 'Batter',
  Balls = 'Balls',
  Strikes = 'Strikes',
  Outs = 'Outs',
  Inning = 'Inning',
  PitcherDexterity = 'P. Dex',
  BattingSide = 'Bat. S',
  TaggedPitch = 'Tagged Pitch',
  PitchCall = 'Pitch Call',
  HitType = 'Hit Type',
  PlayResult = 'Play Result',
  OutsOnPlay = 'Outs On Play',
  RunsScored = 'Runs Scored',
  VerticalReleaseAngle = 'Vert. Rel. Angle',
  HorizontalReleaseAngle = 'Horz. Rel. Angle',
  SpinRate = 'Spin rate',
  SpinAxis = 'Spin axis',
  Extension = 'Extension',
  VerticalBreak = 'Vert. Break',
  HorizontalBreak = 'Horz. Break',
  KOrBB = 'K or BB',
  ReleaseSpeed = 'Rel. Speed',
  Tilt = 'Tilt',
  ReleaseHeight = 'Rel. Height',
  ReleaseSide = 'Rel. Side',
  InducedVerticalBreak = 'Induced Vert. Break',
  PlateLocHeight = 'Plate Loc. Height',
  PlateLocSide = 'Plate Loc. Side',
  HitExitSpeed = 'Exit Speed',
  HitEstCarry = 'Est. Carry',
  HitDirection = 'Direction',
  HitBearing = 'Bearing',
  Changes = 'Changes',
}
